import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  public static urlValidator(): ValidatorFn {
    let urlRegex: RegExp =
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    return (control: AbstractControl): { [key: string]: any } => {
      let value = control.value ? <string>control.value : null;
      if (!value || !value.trim().length) {
        return null;
      }
      return value && value.trim().length && value.match(urlRegex)
        ? null
        : { urlPattern: { value } };
    };
  }

  public static illegalCharacterValidator(
    illegal: string,
    name: string,
    errorMessage: string
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let value = control.value ? <string>control.value : null;
      if (!value || !value.trim().length) {
        return null;
      }

      var error = null;
      if (value.includes(illegal)) {
        error = {};
        error[name] = errorMessage;
      }

      return error;
    };
  }
}
